import React, { Fragment } from 'react';
import { Intro, Slideshow, slideTextTypes, slideTypes } from 'dea-core';
import img1 from '../../assets/images/U1-T1-08A_R.svg';
import img2 from '../../assets/images/U1-T1-08B_R.svg';
import img3 from '../../assets/images/U1-T1-08C_R.svg';
import img4 from '../../assets/images/U1-T1-08D_R.svg';
import img5 from '../../assets/images/U1-T1-08E_L.svg';
import img6 from '../../assets/images/U1-T1-08F_R.svg';
import audio1 from '../../assets/vo/Opioid-M-One-10-NEW.mp3';
import audio2 from '../../assets/vo/Opioid-M-One-10A-NEW.mp3';
import audio3 from '../../assets/vo/Opioid-M-One-10B-NEW.mp3';
import audio4 from '../../assets/vo/Opioid-M-One-10C-NEW.mp3';
import audio5 from '../../assets/vo/Opioid-M-One-10D-NEW.mp3';
import audio6 from '../../assets/vo/Opioid-M-One-10E-NEW.mp3';

const slides = [
  {
    SlideType: slideTypes.HorizontalPan,
    panDirection: 'right',
    // duration: 0.1,
    duration: 22,
    image: img1,
    imageText: '',
    text: {
      type: slideTextTypes.BottomText,
      text: 'Heroin and Illicit Fentanyl'
    },
    vo: {
      sources: [
        {
          src: audio1
        }
      ],
      transcript:
        'After the influx of opioid prescriptions, which undoubtedly increased opioid dependency and addiction,' +
        ' those with misuse disorders often turned to street drugs like heroin and illicit fentanyl to satisfy their' +
        ' cravings. There are a few factors that brought this turn to street drugs to an epidemic level.'
    }
  },
  {
    SlideType: slideTypes.HorizontalPan,
    panDirection: 'left',
    // duration: 0.1,
    duration: 16,
    image: img2,
    imageText: '',
    text: {
      type: slideTextTypes.BottomText,
      text: 'Heroin production increased six-fold.'
    },
    vo: {
      sources: [
        {
          src: audio2
        }
      ],
      transcript:
        'Between 2005 and 2019, heroin production in Mexico increased sixfold. And, improved technology and distribution by heroin sources increased the availability of easily injectable heroin.'
    }
  },
  {
    SlideType: slideTypes.HorizontalPan,
    panDirection: 'right',
    // duration: 0.1,
    duration: 4,
    image: img3,
    imageText: 'Highly Addictive',
    text: {
      type: slideTextTypes.BottomText,
      text: 'Highly Addictive'
    },
    vo: {
      sources: [
        {
          src: audio3
        }
      ],
      transcript: 'And, heroin is highly addictive.'
    }
  },
  {
    SlideType: slideTypes.HorizontalPan,
    panDirection: 'right',
    // duration: 0.1,
    duration: 15,
    image: img4,
    imageText: '',
    text: {
      type: slideTextTypes.BottomText,
      text: 'Fentanyl is 50 to 100 times more potent than morphine.'
    },
    vo: {
      sources: [
        {
          src: audio4
        }
      ],
      transcript:
        'Prescribed fentanyl is a synthetic opioid that is 50 to 100 times more potent than morphine. In prescription form, it is often used to treat severe pain resulting from cancer, or to manage pain immediately after surgery.'
    }
  },
  {
    SlideType: slideTypes.HorizontalPan,
    panDirection: 'left',
    // duration: 0.1,
    duration: 21,
    image: img5,
    imageText: '',
    text: {
      type: slideTextTypes.BottomText,
      text: 'Illicit fentanyl is devastating communities.'
    },
    vo: {
      sources: [
        {
          src: audio5
        }
      ],
      transcript:
        'But this is not the fentanyl that is devastating communities and lives. The fentanyl largely responsible for fatal overdoses is illicitly manufactured fentanyl, often coming from laboratories in China and Mexico. Foreign laboratories make illicit fentanyl for pennies on the dollar and ship them through U.S. mail.'
    }
  },
  {
    SlideType: slideTypes.HorizontalPan,
    panDirection: 'right',
    // duration: 0.1,
    duration: 8,
    image: img6,
    imageText: '',
    text: {
      type: slideTextTypes.BottomText,
      text:
        'A heroin user or counterfeit prescription pill user may not know if they are also consuming illicit fentanyl.'
    },
    vo: {
      sources: [
        {
          src: audio6
        }
      ],
      transcript:
        'Illicit fentanyl is often found mixed with, or substituted for, heroin or counterfeit or fake prescription' +
        ' pills.'
    }
  }
];

export default {
  title: 'Heroin and Illicit Fentanyl',
  path: '/elaborate/heroin-and-illicit-fentanyl',
  content: (
    <Fragment>
      <Intro
        title="Heroin and Illicit Fentanyl"
        direction="Select the play button below to begin."
      />
      <Slideshow slides={slides} />
    </Fragment>
  )
};



// WEBPACK FOOTER //
// ./src/data/elaborate/HeroinAndIllicitFentanyl.js